import { Box, Icon, Text, VStack } from "@chakra-ui/react";
import { LogOut } from "lucide-react";
import {
  DialogActionButton,
  DialogActionRow,
} from "../common/DialogActionButton";
import DialogCommon from "../common/DialogCommon";
import { usePriceLock } from "../../contexts/PriceLockContext";

interface Props {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  loading?: boolean;
}

export default function SignOutConfirmDialog({
  open,
  onConfirm,
  onCancel,
  loading = false,
}: Props) {
  const { lockedPricing } = usePriceLock();

  return (
    <DialogCommon
      open={open}
      onClose={onCancel}
      closeDisabled={loading}
      title="Sign out of HomeHelpy?"
      eyebrow="Account Session"
      icon={LogOut}
      tone="primary"
      actions={
        <DialogActionRow templateColumns={{ base: "1fr 1fr", tablet: "1fr 1fr" }} gap="0.6rem">
          <DialogActionButton action="dismiss" buttonSize="compact" onClick={onCancel} disabled={loading}>
            Cancel
          </DialogActionButton>
          <DialogActionButton
            action="confirm"
            buttonSize="compact"
            gap="0.45rem"
            loading={loading}
            disabled={loading}
            onClick={onConfirm}
          >
            Sign Out
            <Icon as={LogOut} boxSize={4} />
          </DialogActionButton>
        </DialogActionRow>
      }
    >
      <Box px={{ base: "1.45rem", tablet: "1.75rem" }} pt="1.15rem" pb="0.9rem">
        <VStack gap="0.85rem" align="stretch">
          <Text fontSize="0.88rem" color="#64748B" lineHeight="1.5" textAlign="center">
            You will be signed out on this device. Your bookings and account details will stay saved.
          </Text>
          {lockedPricing && (
            <Text fontSize="0.82rem" color="#92400E" lineHeight="1.5" textAlign="center" fontWeight="700">
              You have a locked price that will be lost if you sign out. It may be more expensive next time.
            </Text>
          )}
        </VStack>
      </Box>
    </DialogCommon>
  );
}
